/* Sherri Hill 2026 — collection page (sections/sh2-collection.liquid).
   Filter drawer (open/close, open at a facet, live result count), sort, Load More (appends the next page in place;
   the button is a real ?page=N link without JS), and grid video (mounts the <video> near the viewport). */
(function () {
  'use strict';

  var quiet = function () {
    return (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
      (navigator.connection && navigator.connection.saveData);
  };

  /* ---------- Grid video ---------- */
  function mountVideo(box) {
    if (box.dataset.mounted) return;
    var src = box.getAttribute('data-src');
    if (!src) return;
    box.dataset.mounted = '1';
    var v = document.createElement('video');
    v.className = 'sh2-media__video';
    v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true; v.preload = 'auto';
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
    v.src = src;
    v.addEventListener('playing', function () { box.classList.add('is-playing'); });
    box.appendChild(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); mountVideo(e.target); } });
  }, { rootMargin: '200px' }) : null;
  function initVideos(root) {
    root.querySelectorAll('[data-sh2-video]:not([data-ready])').forEach(function (box) {
      box.setAttribute('data-ready', '1');
      if (quiet() || !io) {
        var btn = box.querySelector('.sh2-media__play');
        if (btn) {
          btn.hidden = false;
          btn.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); btn.hidden = true; mountVideo(box); });
        }
        return;
      }
      io.observe(box);
    });
  }

  /* ---------- Page ---------- */
  function init(root) {
    if (root.dataset.sh2Init) return;
    root.dataset.sh2Init = '1';
    var sectionId = root.getAttribute('data-section-id');
    var drawer = root.querySelector('[data-sh2-drawer]');
    var form = root.querySelector('[data-sh2-filter-form]');
    var applyBtn = root.querySelector('[data-sh2-apply]');
    var label = root.getAttribute('data-count-label') || 'dresses';
    var labelCap = label.charAt(0).toUpperCase() + label.slice(1);
    var lastFocus = null;

    initVideos(root);

    function openDrawer(group) {
      if (!drawer) return;
      lastFocus = document.activeElement;
      if (group) {
        drawer.querySelectorAll('[data-sh2-group]').forEach(function (d) { d.open = d.getAttribute('data-sh2-group') === group; });
      }
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var target = group ? drawer.querySelector('[data-sh2-group="' + group + '"] summary') : drawer.querySelector('.sh2-drawer__close');
      if (target) target.focus({ preventScroll: true });
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    root.querySelectorAll('[data-sh2-filter-open]').forEach(function (b) {
      b.addEventListener('click', function () { openDrawer(b.getAttribute('data-sh2-filter-open') || null); });
    });
    root.querySelectorAll('[data-sh2-filter-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer(); });

    /* Live count: re-render this section with the staged filters and read its data-count */
    var countTimer = null, countSeq = 0;
    function stagedQuery() {
      var p = new URLSearchParams(new FormData(form));
      p.forEach(function (v, k) { if (v === '') p.delete(k); });
      return p;
    }
    function updateCount() {
      if (!form || !applyBtn) return;
      clearTimeout(countTimer);
      countTimer = setTimeout(function () {
        var seq = ++countSeq;
        var p = stagedQuery();
        p.set('section_id', sectionId);
        applyBtn.setAttribute('aria-busy', 'true');
        fetch(form.getAttribute('action') + '?' + p.toString(), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (seq !== countSeq) return;
            var m = html.match(/data-count="(\d+)"/);
            if (m) applyBtn.textContent = 'Show ' + m[1] + ' ' + labelCap;
            applyBtn.removeAttribute('aria-busy');
          })
          .catch(function () { applyBtn.removeAttribute('aria-busy'); });
      }, 250);
    }
    if (form) {
      form.addEventListener('change', function (e) {
        var l = e.target.closest('.sh2-check, .sh2-size-picker__opt');
        if (l) l.classList.toggle('is-checked', e.target.checked), l.classList.toggle('is-selected', e.target.checked);
        var g = e.target.closest('[data-sh2-group]');
        if (g) {
          var picked = [].map.call(g.querySelectorAll('input:checked'), function (i) { var t = i.closest('label'); return t ? t.textContent.trim() : i.value; });
          var s = g.querySelector('.sh2-drawer__summary'); if (s) s.textContent = picked.join(', ');
        }
        updateCount();
      });
      form.addEventListener('submit', function () {
        form.querySelectorAll('input').forEach(function (i) { if ((i.type === 'number' || i.type === 'hidden') && i.value === '') i.disabled = true; });
      });
      var clear = root.querySelector('[data-sh2-filter-clear]');
      if (clear) clear.addEventListener('click', function (e) {
        e.preventDefault();
        form.querySelectorAll('input[type=checkbox]').forEach(function (i) { i.checked = false; var l = i.closest('label'); if (l) l.classList.remove('is-checked', 'is-selected'); });
        form.querySelectorAll('input[type=number]').forEach(function (i) { i.value = ''; });
        form.querySelectorAll('.sh2-drawer__summary').forEach(function (s) { s.textContent = ''; });
        updateCount();
      });
    }

    /* Sort */
    root.querySelectorAll('[data-sh2-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var f = document.getElementById(sel.getAttribute('form'));
        if (!f) return;
        var h = f.querySelector('input[name="sort_by"]');
        if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'sort_by'; f.appendChild(h); }
        h.value = sel.value;
        root.querySelectorAll('[data-sh2-sort]').forEach(function (o) { if (o !== sel) o.disabled = true; });
        sel.disabled = true;
        f.submit();
      });
    });

    /* Load more */
    var more = root.querySelector('[data-sh2-loadmore]');
    var grid = root.querySelector('[data-sh2-grid]');
    function bindNext() {
      var next = more && more.querySelector('[data-sh2-next]');
      if (!next || !grid) return;
      next.addEventListener('click', function (e) {
        e.preventDefault();
        if (more.classList.contains('is-loading')) return;
        more.classList.add('is-loading');
        var url = new URL(next.href, location.href);
        url.searchParams.set('section_id', sectionId);
        fetch(url.toString(), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var g = doc.querySelector('[data-sh2-grid]');
            var m = doc.querySelector('[data-sh2-loadmore]');
            if (!g || !m) { location.href = next.href; return; }
            var first = null;
            [].slice.call(g.children).forEach(function (c) { var n = document.importNode(c, true); if (!first && n.classList.contains('sh2-card')) first = n; grid.appendChild(n); });
            var nm = document.importNode(m, true);
            var prev = nm.querySelector('.sh2-loadmore__prev'); if (prev) prev.remove();
            more.replaceWith(nm);
            more = nm;
            initVideos(root);
            if (first) first.focus({ preventScroll: true });
            bindNext();
          })
          .catch(function () { location.href = next.href; });
      });
    }
    bindNext();
  }

  function boot() { document.querySelectorAll('.sh2-coll').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
